export default __webpack_public_path__ + "static/media/gazpacho.c281037a.ttf";